import { gql } from '@apollo/client';
import { mutate } from './Apollo';
import { getShownMatchBrandIds } from '../../Helpers/events';
import logToConsole from '../../Utils/logToConsole';

const STORE_SELECT_AND_CONNECT_SHOWN_EVENT = gql`
  mutation StoreSelectAndConnectShownEvent(
    $visitorId: String!
    $formId: String!
    $subcategoryId: String
    $matches: SelectAndConnectShownMatchesInput!
    $brandIds: [String!]!
    $testMode: Boolean
  ) {
    storeSelectAndConnectShownEvent(
      visitorId: $visitorId
      formId: $formId
      subcategoryId: $subcategoryId
      matches: $matches
      brandIds: $brandIds
      testMode: $testMode
    ) {
      eventStored
    }
  }
`;

const toStringOrNull = (value) =>
  value === null || value === undefined ? null : String(value);

const toGatewayShownMatch = (match) => ({
  supplierId: toStringOrNull(match?.supplierId),
  brandId: toStringOrNull(match?.brandId),
  brandRevisionId: toStringOrNull(match?.brandRevisionId),
  brandName: toStringOrNull(match?.brandName),
  matchLevel: toStringOrNull(match?.matchLevel),
});

/**
 * Fire-and-forget hand-over of the selectAndConnectShown event (the exact
 * matches displayed on the select-and-connect component) to the gateway, which
 * stores it in the chameleon-backend events table. Mirrors the GTM
 * selectAndConnectShown event payload; failures never affect the journey.
 */
// eslint-disable-next-line import/prefer-default-export
export const sendSelectAndConnectShownEventToGateway = ({
  visitorId,
  formId,
  subcategoryId,
  matches,
  testMode,
}) => {
  if (!visitorId || !formId || !matches) return;
  if (
    !['production-na', 'production-eu', 'staging', 'development'].includes(
      process.env.NEXT_PUBLIC_ENV
    )
  ) {
    return;
  }

  mutate({
    mutation: STORE_SELECT_AND_CONNECT_SHOWN_EVENT,
    variables: {
      visitorId: String(visitorId),
      formId: String(formId),
      subcategoryId:
        subcategoryId !== undefined && subcategoryId !== null
          ? String(subcategoryId)
          : undefined,
      matches: {
        submitted: (matches.submitted ?? []).map(toGatewayShownMatch),
        shown: (matches.shown ?? []).map(toGatewayShownMatch),
      },
      brandIds: getShownMatchBrandIds(matches).map(String),
      testMode,
    },
  }).catch((error) => {
    logToConsole.warn(
      'sendSelectAndConnectShownEventToGateway - failed to store event',
      error
    );
  });
};
